import CustomLabel from '@/common/components/base/customLabel/CustomLabel';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import CardButton from '@/common/components/cardButton/CardButton';
import MainLayout from '@/common/components/layouts/MainLayout';
import getCurrentFileStateQueryOption from '@/common/queries/getCurrentFileState/getCurrentFileStateQueryOption';
import { FileStateType } from '@/common/types/Files.type';
import AdjusterImageIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/adjusterImageIcon.svg?react';
import AskedImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/askedImagesIcon.svg?react';
import CustomerImageIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/customerImageIcon.svg?react';
import SignatureImageIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/signatureImageIcon.svg?react';
import VisitTimeSet from '@/modules/adjusterReportModules/IncidentParticipants/components/images/initialVisit/initialVisit';
import {
  INITIAL_IMAGES_LINKS,
  INITIAL_VISIT_CUSTOMER_IMAGES_LINKS,
} from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitLink';
import { getDamagedImagesTabsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImagesTabs/getDamagedImagesTabsQueryOptions';
import getDamagedImageTabsAlertsQueryOptions from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImageTabsAlerts/getDamagedImageTabsAlertsQueryOptions';
import { ImageTabType } from '@/modules/adjusterReportModules/IncidentParticipants/types/images';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title=" تصاویر / بازدید اولیه" header="titleHeader">
      <InitialVisitImagesTabs />
    </MainLayout>
  );
};

const InitialVisitImagesTabs = () => {
  const navigate = useNavigate();
  const { id, damagedId } = useParams();
  const { data } = useQuery(
    getDamagedImagesTabsQueryOptions({
      damaged_id: +damagedId!,
      id: +id!,
      type: 'initial_visit',
    }),
  );

  const { isPending } = useQuery(
    getDamagedImageTabsAlertsQueryOptions({
      damage_id: +damagedId!,
      id: +id!,
      type: 'initial',
    }),
  );
  const { data: currentFileState } = useQuery(
    getCurrentFileStateQueryOption({ id: +id! }),
  );
  const renderRoute = (item: ImageTabType) => {
    let tabIcon: Record<ImageTabType['name'], string> = {
      adjuster_image: INITIAL_IMAGES_LINKS.ADJUSTER_IMAGES(+id!),
      customer_image: INITIAL_VISIT_CUSTOMER_IMAGES_LINKS.ENTRY_TAB(id!),
      signature: item.editable
        ? INITIAL_IMAGES_LINKS.INITIAL_VISIT_SIGNATURE(+id!)
        : INITIAL_IMAGES_LINKS.INITIAL_VISIT_SIGNATURE_SHOW(+id!),
    };
    return tabIcon[item.name];
  };
  const goToFile = (item: ImageTabType) => {
    navigate(renderRoute(item));
  };

  return (
    <Box pt="2rem">
      {isPending ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <Box
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            position: 'relative',
            top: '-5px',
          })}
        >
          {currentFileState?.state.const === FileStateType.IN_PROGRESS ? (
            <Box
              className={css({
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
              })}
            >
              <TitleDescription>بازدید</TitleDescription>
              <VisitTimeSet />
            </Box>
          ) : null}

          <Box
            className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            })}
          >
            <TitleDescription>دسته بندی</TitleDescription>
            <Box>
              {data?.grouping.map((item, index) =>
                !item.exists ? null : (
                  <CardButton
                    key={item?.name}
                    cardProps={{
                      className: css({
                        marginY: '1rem',
                        marginTop: index === 0 ? '0rem' : '1rem',
                        marginBottom:
                          index === data.grouping.length - 1 ? '0rem' : '1rem',
                      }),
                      onClick: () => goToFile(item),
                    }}
                    hasArrow
                    renderTag={() =>
                      item?.label && (
                        <CustomLabel
                          title={item?.label?.fa_const}
                          color={
                            item?.label?.const === 'uncompleted'
                              ? 'black'
                              : 'green'
                          }
                        />
                      )
                    }
                    renderIcon={() => renderIcon(item?.name)}
                    title={item?.fa_name}
                  />
                ),
              )}
            </Box>
          </Box>

          {data?.corrective_image ? (
            <Box>
              <TitleDescription>تصاویر درخواستی</TitleDescription>
              <CardButton
                title={data?.corrective_image[0]?.fa_name}
                cardProps={{
                  className: css({ marginY: '1rem' }),
                  onClick: () =>
                    navigate(
                      INITIAL_IMAGES_LINKS.INITIAL_VISIT_CORRECTIVE_IMAGES(id!),
                    ),
                }}
                renderIcon={() => <AskedImagesIcon />}
                hasArrow
                renderTag={() => (
                  <CustomLabel
                    title={data?.corrective_image[0]?.count!}
                    color={'orange'}
                  />
                )}
              />
            </Box>
          ) : null}
        </Box>
      )}
    </Box>
  );
};

const renderIcon = (tabName: ImageTabType['name']) => {
  let tabIcon: Record<ImageTabType['name'], React.JSX.Element> = {
    adjuster_image: <AdjusterImageIcon />,
    customer_image: <CustomerImageIcon />,
    signature: <SignatureImageIcon />,
  };
  return tabIcon[tabName];
};
